import { createAction } from 'redux-actions-helpers'
import { ModuleType, ModuleScreenType } from './types'

export const fetchModule = createAction(
  '@@admin-edit-module/FETCH_MODULE',
  (id: string): any => ({ id })
)

export const fetchModuleSuccess = createAction(
  '@@admin-edit-module/FETCH_MODULE_SUCCESS',
  (result: ModuleType): any => ({ result })
)

export const fetchModuleFailure = createAction(
  '@@admin-edit-module/FETCH_MODULE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchModuleScreens = createAction(
  '@@admin-edit-module/FETCH_MODULE_SCREENS',
  (id: string, mid: string): any => ({ id, mid })
)

export const fetchModuleScreensSuccess = createAction(
  '@@admin-edit-module/FETCH_MODULE_SCREENS_SUCCESS',
  (result: ModuleScreenType[]): any => ({ result })
)

export const fetchModuleScreensFailure = createAction(
  '@@admin-edit-module/FETCH_MODULE_SCREENS_FAILURE',
  (error: string): any => ({ error })
)

export const editModule = createAction(
  '@@admin-edit-module/EDIT_MODULE',
  (id: string, title: string, position: number, available_at: string): any => ({
    id,
    title,
    position,
    available_at,
  })
)

export const editModuleSuccess = createAction(
  '@@admin-edit-module/EDIT_MODULE_SUCCESS'
)

export const editModuleFailure = createAction(
  '@@admin-edit-module/EDIT_MODULE_FAILURE',
  (error: string): any => ({ error })
)

export const removeModule = createAction(
  '@@admin-edit-module/REMOVE_MODULE',
  (id: string): any => ({ id })
)

export const removeModuleSuccess = createAction(
  '@@admin-edit-module/REMOVE_MODULE_SUCCESS'
)

export const removeModuleFailure = createAction(
  '@@admin-edit-module/REMOVE_MODULE_FAILURE',
  (error: string): any => ({ error })
)

export const createScreen = createAction(
  '@@admin-edit-module/CREATE_SCREEN',
  (
    id: string,
    mid: string,
    title: string,
    typeScreen: 'first' | 'last'
  ): any => ({
    id,
    mid,
    title,
    typeScreen,
  })
)

export const createScreenSuccess = createAction(
  '@@admin-edit-module/CREATE_SCREEN_SUCCESS'
)

export const createScreenFailure = createAction(
  '@@admin-edit-module/CREATE_SCREEN_FAILURE',
  (error: string): any => ({ error })
)

export const editScreen = createAction(
  '@@admin-edit-module/EDIT_SCREEN',
  (id: string, mid: string, sid: string, title: string): any => ({
    id,
    mid,
    sid,
    title,
  })
)

export const editScreenSuccess = createAction(
  '@@admin-edit-module/EDIT_SCREEN_SUCCESS'
)

export const editScreenFailure = createAction(
  '@@admin-edit-module/EDIT_SCREEN_FAILURE',
  (error: string): any => ({ error })
)

export const removeScreen = createAction(
  '@@admin-edit-module/REMOVE_SCREEN',
  (id: string, mid: string, sid: string): any => ({ id, mid, sid })
)

export const removeScreenSuccess = createAction(
  '@@admin-edit-module/REMOVE_SCREEN_SUCCESS'
)

export const removeScreenFailure = createAction(
  '@@admin-edit-module/REMOVE_SCREEN_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-edit-module/DESTROY')
